import type { Cart } from '@/services/cartService'

export interface CheckoutProfileInfo {
  orgId: number
  siteId: number
  locationId: number
  specialAccommodations: string
}

export interface CheckoutDraft {
  referralSource: string
  customReferralSource: string
  profile?: {
    info: CheckoutProfileInfo
    savedInfo: CheckoutProfileInfo | null
    displayNames: { region: string; district: string; campus: string }
    sid: string
    verified: boolean
    editing: boolean
  }
}

// Protected routes refresh the user object, so scope by stable identity.
// authStore clears this in-memory draft when the authentication session changes.
let current: { userId: string; cartKey: string; draft: CheckoutDraft } | undefined

function cartKey(cart: Cart): string {
  return JSON.stringify(cart.items.map(item => [
    item.sessionId, item.addedAt, item.registrationTarget ?? null,
  ]))
}

type DraftUser = { id?: string; sid?: string; email?: string }

export function getCheckoutUserKey(user: DraftUser | null): string | undefined {
  return user?.id || user?.sid || user?.email?.trim().toLowerCase() || undefined
}

export function getCheckoutDraft(user: DraftUser | null, cart: Cart): CheckoutDraft | undefined {
  const userId = getCheckoutUserKey(user)
  if (userId && current && current.userId === userId && current.cartKey === cartKey(cart) && cart.items.length > 0) {
    return current.draft
  }
  return undefined
}

export function saveCheckoutDraft(user: DraftUser | null, cart: Cart, draft: CheckoutDraft): void {
  const userId = getCheckoutUserKey(user)
  if (userId && cart.items.length > 0) current = { userId, cartKey: cartKey(cart), draft }
}

export function clearCheckoutDraft(): void {
  current = undefined
}
